# Globalni detektor dragování souborů z OS – aktivuje pointer-events na overlay formách
if not window._dzDragInit
  window._dzDragInit = true
  _dragCounter = 0
  $(document).on 'dragenter', (e) ->
    types = e.originalEvent?.dataTransfer?.types
    if types and Array.from(types).indexOf('Files') >= 0
      _dragCounter++
      $('body').addClass 'dz-file-dragging'
  $(document).on 'dragleave', (e) ->
    _dragCounter = Math.max(0, _dragCounter - 1)
    if _dragCounter is 0
      $('body').removeClass 'dz-file-dragging'
  $(document).on 'drop', ->
    _dragCounter = 0
    $('body').removeClass 'dz-file-dragging'

$.fn.extend
  frameEvents: (options) ->
    settings = 
      drop: false
      clickable_drop: true

    
    settings = $.extend settings, options

    frame = $(@)

    last_val = 0
    
    output = {
    
        init: () ->
            # naplnime objekty
            frame.find('.object').each ->
                $(@).objectEvents({parent: frame})

            frame.find('.ico.clear').click ->
                output.clear()

                false

            frame.find('.ico.add_text').click ->
                output.insertText('Sem, prosím, vložte text...', 10, 10)
                false

            frame.mouseover( ->
                if !frame.hasClass('empty') && frame.hasClass('standard') && $('#page_detail').length
                    frame.addClass 'activated'
            ).mouseout ->
                frame.removeClass 'activated'

            success_count = 0
            if (settings.drop)
                console.log settings.clickable_drop
                is_empty = frame.hasClass('empty')
                frame.find('form').dropzone
                    previewTemplate: '
                        <div class="dz-preview dz-file-preview">
                            <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>
                        </div>
                    ',
                    clickable: if is_empty then settings.clickable_drop else false
                    
                    # maxFiles: 1


                    init: ->

                        this.on 'success', (file, out) ->
                            success_count++
                            if out == 'upload_error'
                              new swal
                                title: 'Neočekávaná příloha'
                                text: 'Jejda, s tímto datovým typem se asi neumíme poprat. Očekávaná data jsou: jpg, jpeg, png'
                                icon: 'error'
                                confirmButtonText: 'Chápu!'
                                showCancelButton: false
                            else
                                # alert 'joooo'
                                if success_count == 1 
                                    output.insert(out)
                                photoContainer.reload()
                            
                            loadPage()

                            return
                        return
                        this.on 'totaluploadprogress', (uploadProgress, totalBytes, totalBytesSent) ->
                            console.log uploadProgress, totalBytes, totalBytesSent
                            return
                        return
                    
            return

        clear: () ->
            $.ajax(
              dataType: 'JSON'
              method: 'POST'
              data:
                app_url: window.location.pathname
                frame_id: frame.data('frame_id')
              url: '/ajax/app/clear_frame/'
            ).done((data) ->
                console.log data

                if data.frame_array
                    $.each data.frame_array, (key, value) ->
                        $('.frame[data-frame_id='+key+']').html value.html
                        $('.frame[data-frame_id='+key+']').addClass 'empty'
                        $('.frame[data-frame_id='+key+']').frameEvents({drop: true, clickable_drop: true})
                else
                    frame.html data.empty_frame.html
                    frame.addClass 'empty'
                
                photoContainer.reload()

                # loadPage()
                return
            ).fail (jqXHR, textStatus) ->
                console.warn 'Error: ' + jqXHR.responseText
                return
            return   

        insert: (image_name) ->
           
            $.ajax(
              dataType: 'JSON'
              method: 'POST'
              data:
                app_url: window.location.pathname
                photo: image_name
                frame_id: frame.data('frame_id')
              url: '/ajax/app/photo_insert/'
            ).done((data) ->

                console.log 'INSER'
                console.log data
                # frame_array se vraci kdyz se zmeni vic jak jeden frame, u pexes napriklad
                page = frame.parent('.page')
                if data.frame_array
                    $.each data.frame_array, (key, value) ->
                        # $('.frame[data-frame_id='+key+']').remove();

                        # new_frame = page.append(value.html)
                        # new_frame.frameEvents({drop: true, clickable_drop: true})
                        $('.frame[data-frame_id='+key+']').html value.html
                        $('.frame[data-frame_id='+key+']').removeClass 'empty'
                        $('.frame[data-frame_id='+key+']').frameEvents({drop: true, clickable_drop: true})

                else 
                    frame.html data.new_frame_html
                
                # Inicializace – klidně s malým odkladem po prvním paintu
                $('img[data-full_image!=""]').each ->
                  $img = $(@)
                  setTimeout (-> upgradeToFull($img)), 200
                  return

                output.init()
                frame.removeClass 'empty'
                # photoContainer.reload()
                if data.clone
                    loadPage()
                return
            ).fail (jqXHR, textStatus) ->
                console.warn 'Error: ' + jqXHR.responseText
                return
            return              
     

    }

    output.init()
    # output.dropzone()
    # output.draggable()
    # output.reset()

    return output